<template>
  <!--
      作者：luoyiming
      时间：2020-06-01
      描述：插件中心-文章-编辑
    -->
  <div class="product-add pb50" v-loading="loading">
    <!--编辑文章-->
     <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
       <div class="common-form">编辑任务</div>
       <el-form-item label="二维码模板缩略图">
         <div>
           <el-button type="primary" @click="openUpload">上传图片</el-button>
           <img class="mt10" v-img-url="'image.file_path',form"  width="120px;" alt="" />
          <p class="gray">*建议750X1334</p>
           <!--上传图片组件-->
           <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
         </div>
       </el-form-item>
       <el-form-item label="模板类型">
         <el-radio-group v-model="form.type">
           <el-radio :label="'10'">送朋友</el-radio>
           <el-radio :label="'20'">送父母</el-radio>
           <el-radio :label="'30'">送客户</el-radio>
           <el-radio :label="'40'">送小孩</el-radio>
         </el-radio-group>
       </el-form-item>
       <!--提交-->
       <div class="common-button-wrapper">
         <el-button size="small" type="info" @click="cancelFunc" :loading="loading">取消</el-button>
         <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
       </div>
     </el-form>
  </div>
</template>

<script>
  import CodeTemplateApi from '@/api/CodeTemplate.js';
import Upload from '@/components/file/Upload';

export default {
  components: {
    /*图片上传*/
    Upload: Upload
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      /*是否加载完成*/
      loading: true,
      /*form表单数据*/
      form: {
        image_id: '',
        type: '10',
      },

      /*验证规则*/
      rules: {
      }
    };
  },
  created() {

    this.getDetail();

  },

  methods: {
    /*上传*/
    openUpload() {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image.file_path = e[0].file_path;
      }
      this.isupload = false;
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      const params = self.$route.query.code_template_id;
      CodeTemplateApi.getTemplate({code_template_id: params},true).then(res => {
          self.form = res.data.model;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*修改任务*/
    onSubmit() {
      let self = this;
      let params = this.form;
      // 取到路由带过来的参数
      CodeTemplateApi.saveTemplate(params, true)
        .then(data => {
          self.$message({
            message: data.msg,
            type: 'success'
          });
          self.$router.push('/plus/codetemplate/index');
        })
        .catch(error => {});
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$router.push({
        path: '/plus/codetemplate/index'
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/codetemplate/codetemplate/edit.vue